import get from 'lodash/get';
import { columnName, tableName } from 'app/area/case/case-data-model';

type User = { value: string | number; description?: string };
type EntryLogValues = { egressTimeRecordedBy?: User };

const findStoredRecordedBy = (rowEntity: any, entryLogValues?: EntryLogValues): User | undefined =>
  [
    entryLogValues?.egressTimeRecordedBy,
    get(rowEntity, `${columnName[tableName.involvedPersonInside]?.egressTimeRecordedBy}[0]`)
  ].find(user => user?.value);

export const resolveEgressRecordedBy = (
  rowEntity: any,
  currentUser?: User,
  entryLogValues?: EntryLogValues
): string | undefined => {
  const storedRecordedBy = findStoredRecordedBy(rowEntity, entryLogValues);

  return storedRecordedBy ? storedRecordedBy.description : currentUser?.description;
};
